"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "magnacavallo": {
    "5f51df25": [{
      "hkey": "9c978ff4",
      "slug": "magnacavallo",
      "name": "Magnacavallo",
      "primary": true,
      "skipSearch": false
    }],
    "agnolo": [{
      "hkey": "9c978ff4",
      "slug": "magnacavallo",
      "name": "Magnacavallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "47ac14fa": [{
      "hkey": "9c978ff4",
      "slug": "magnacavallo",
      "name": "Magnacavallo",
      "primary": true,
      "skipSearch": false
    }],
    "magnacavallo": [{
      "hkey": "9c978ff4",
      "slug": "magnacavallo",
      "name": "Magnacavallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4bf40641": [{
      "hkey": "9c978ff4",
      "slug": "magnacavallo",
      "name": "Magnacavallo",
      "primary": true,
      "skipSearch": false
    }],
    "parolare": [{
      "hkey": "9c978ff4",
      "slug": "magnacavallo",
      "name": "Magnacavallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f2ca8c90": [{
      "hkey": "9c978ff4",
      "slug": "magnacavallo",
      "name": "Magnacavallo",
      "primary": true,
      "skipSearch": false
    }],
    "quattro-case": [{
      "hkey": "9c978ff4",
      "slug": "magnacavallo",
      "name": "Magnacavallo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;